import React from "react";

const FullPageLoader = () => {
    return (
        <div className="fp-container">
            <div className="spinner spinner-primary fp-loader"></div>
        </div>
    );
};

export default FullPageLoader;